<template>
    <div class="main-wrapper with-tabs no-padding scroll-y custom-scrollbar view-training-exam">

        <div class="inner-padding">

            <page-title :title="'Egzamin do szkolenia'" :back="true" :routeName="'Trainings'"></page-title>

            <div v-if="loading">
                <p><b>Ładuję egzamin...</b></p>
            </div>

            <div v-else class="form">
                <div v-for="(question,Qindex) in tempExam" :key="Qindex">
                    <div v-if="Qindex+1 === step">
                        <div class="form-group">
                            <h3 v-if="show">{{ question.question }}</h3>
                            <img v-if="question.image" :src="question.image" style="width: 100%; height: auto"/>
                            <div class="rte">
                                <iframe v-if="question.movie"
                                        :src="question.movie"
                                        width="100%"
                                        height="300"
                                        frameborder="0"
                                        allowfullscreen="allowfullscreen">
                                </iframe>
                            </div>
                            <div class="input-wrapper" v-for="(answer,Aindex) in question.answers" :key="Aindex" style="margin-top: 25px">
                                <!--v-model not working - value is passed as props 'checked'-->
                                <ion-checkbox mode="md"
                                        :checked="exam[Qindex].answers[Aindex].isChecked"
                                        @input="checked = target.value"
                                        @ionChange="handleCheckbox(Qindex, Aindex, $event, question.id, answer.id, question.question, answer.answer, answer.correctness)">
                                </ion-checkbox>
                                <label class="checkbox-label">{{ answer.answer }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <tab-progress
                :step="step"
                :data="exam ? exam : null"
                @finish="postExam"
                :finish_button_loading="loading"
                :finish_button_disabled="loading || this.checkboxes.length == 0"
                :finish_button_label="'Wyślij egzamin'">
        </tab-progress>

    </div>
</template>

<script>
    import api from '@/services/Api';
    import goTo from '@/mixins/goto';
    import { mapState } from 'vuex';

    import PageTitle from '@/components/PageTitle.vue';
    import TabProgress from '@/components/TabProgress.vue';

    export default {
        name: 'TrainingExam',
        components: {PageTitle, TabProgress},
        mixins: [goTo],
        data() {
            return {
                show: false,
                step: 1,
                checkboxes: [],
                tempExam: []
            }
        },
        computed: {
            ...mapState({
                loading: state => state.trainings.loading,
                errors: state => state.trainings.errors,
                exam: state => state.trainings.exam,
            })
        },
        mounted() {
            this.show = true;
            this.$store.dispatch('trainings/KNOWLEDGE_TRAININGS_EXAM_REQUEST', this.$route.params.slug).then(() => {
                this.tempExam = this.exam // copy exam to local
            });
        },
        methods: {
            handleCheckbox(Qindex, Aindex, event, question_id, answer_id, question, answer, correctness) {
                const checkbox = event.target;
                // prepare answers for POST
                let obj = {
                    'question_id': question_id,
                    'answer_id': answer_id,
                    'question': question,
                    'answer' : answer,
                    'correctness' : correctness
                }
                // get index of item
                let index = this.checkboxes.map((item) => {
                    return item.answer_id
                }).indexOf(answer_id);
                // check duplicates
                let isDuplicate = this.checkboxes.some((item) => {
                    return index !== -1 ? true : false
                });
                // checkbox is set true
                if (checkbox.checked) {
                    this.tempExam[Qindex].answers[Aindex].isChecked = true;
                    // push "checked" answer to array, but only unique answers
                    if(!isDuplicate){
                        this.checkboxes.push(obj)
                    }
                }
                // checkbox is set false
                else{
                    this.tempExam[Qindex].answers[Aindex].isChecked = false
                    // remove answer from array at "uncheck"
                    this.checkboxes.splice(index, 1)
                }
            },
            postExam(){
                let payload = {'level_slug': this.$route.params.slug, 'data': { 'exam' : this.checkboxes }};
                this.$store.dispatch('trainings/KNOWLEDGE_TRAININGS_EXAM_STORE', payload)
                    .then(() => {
                        this.goTo('TrainingSummary', this.$route.params.slug)
                    })
                    .catch(() => {
                        this.$store.dispatch('GLOBAL_TOAST',this.errors.exam[0]);
                    })
            }
        }
    }
</script>